<template>
  <el-menu
    :default-active="myEventMenuActiveIndex"
    class="el-menu-small"
    mode="horizontal"
  >
    <el-menu-item index="1"
      ><router-link
        :to="{ path: '/myRegistrationForm', query: { eventId: eventId } }"
        >会议报名表</router-link
      ></el-menu-item
    >
    <el-menu-item index="2"
      ><router-link :to="{ path: '/myThesisList', query: { eventId: eventId } }"
        >会议投稿</router-link
      ></el-menu-item
    >
  </el-menu>
</template>

<script>
export default {
  name: 'MyEventMenu',
  props: {
    myEventMenuActiveIndex: String,
  },
  data() {
    return {
      eventId: '',
    };
  },
  mounted() {
    let eventId = this.$route.query.eventId;
    console.log('menu' + eventId);
    this.eventId = eventId;
  },
  methods: {},
};
</script>

<style scoped></style>
